export const images = {
  default: {
    communityCoverPhoto: '/assets/default_images/community_cover_photo.png',
    communityProfilePhoto: '/assets/default_images/community_profile_photo.png',
    eventCoverPhoto: '/assets/default_images/event_cover_photo.png',
    givingCoverPhoto: '/assets/default_images/giving_cover_photo.png',
    groupCoverPhoto: '/assets/default_images/group_cover_photo.png',
    groupProfilePhoto: '/assets/default_images/group_profile_photo.png',
    imageFileFallback: '/assets/default_images/image_file_fallback.svg',
    organizationCoverPhoto: '/assets/default_images/organization_cover_photo.png',
    organizationProfilePhoto: '/assets/default_images/organization_profile_photo.png',
    programCoverPhoto: '/assets/default_images/program_cover_photo.png',
    programProfilePhoto: '/assets/default_images/program_profile_photo.png',
    reminderCoverPhoto: '/assets/default_images/reminder_cover_photo.png',
    userCoverPhoto: '/assets/default_images/user_cover_photo.png',
    userProfilePhoto: '/assets/default_images/user_profile_photo.png',
    videoCoverPhoto: '/assets/default_images/video_cover_photo.png',
  },
};
